import moment from 'moment'

export const formatDateTime = (date: string | number, unix?: boolean) =>
  unix
    ? moment.unix(Number(date)).format('DD.MM.YY HH:mm')
    : moment(date).format('DD.MM.YY HH:mm')

export const formatDate = (date: string | number, unix?: boolean) =>
  unix
    ? moment.unix(Number(date)).format('DD.MM.YY')
    : moment(date).format('DD.MM.YY')

export const formatTime = (date: string | number, unix?: boolean) =>
  unix
    ? moment.unix(Number(date)).format('HH:mm')
    : moment(date).format('HH:mm')

export const formatCallDuration = (seconds: number) => {
  const duration = moment.duration(seconds, 'seconds')

  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  const secs = duration.seconds()

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}`
  }

  if (minutes > 0) {
    return `${minutes}:${secs.toString().padStart(2, '0')}`
  }

  return `0:${secs}`
}
